import { useState, useEffect } from 'react';

export function useMediaQuery(query) {
  // Inicializar con false (valor seguro para SSR/prerender).
  // El valor real se asigna en useEffect para que el primer render
  // coincida siempre con el HTML prerenderizado y no haya hydration mismatch.
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia(query);
    setMatches(mq.matches);
    const handler = (e) => setMatches(e.matches);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, [query]);

  return matches;
}
